import React, { useState } from 'react';
import { Col, Row } from 'antd';
import moment from 'moment';
import { OrderFilterParams, OrderStatus } from '../types';
import { STATUS_OPTIONS, PAYMENT_METHOD_OPTIONS } from '../helpers';
import StyledButton from 'app/components/StyledButton';
import StyledSelect from 'app/pages/NewAccount/components/StyledSelect';
import StyledDatePicker from 'app/pages/NewAccount/components/StyledDatePicker';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { formatDate } from 'app/pages/NewAccount/CheckTickets/HeaderFilter';
import useWindowSize from 'app/hooks/useWindowSize';
import StyledSearchInput from 'app/pages/NewAccount/components/StyledSearchInput';
import { convertVItoEN } from 'app/pages/NewAccount/CheckTickets/helper';

interface FilterSearchProps {
  onSearch: (filters: OrderFilterParams) => void;
  agentOptions: Array<{ label: string; value: string }>;
  paymentOptions?: Array<{ label: string; value: string }>;
}

export const FilterSearch: React.FC<FilterSearchProps> = ({
  onSearch,
  agentOptions,
  paymentOptions,
}) => {
  const translations = useSelector(selectTranslations);
  const { device } = useWindowSize();
  const isDesktop = device === 'desktop';

  const [orderDate, setOrderDate] = useState<moment.Moment | null>(null);
  const [status, setStatus] = useState<string>(OrderStatus.ALL);
  const [orderCode, setOrderCode] = useState<string>('');
  const [paymentMethod, setPaymentMethod] = useState<string>('');
  const paymentOptionsList =
    paymentOptions && paymentOptions.length > 0
      ? paymentOptions
      : PAYMENT_METHOD_OPTIONS;
  const [agent, setAgent] = useState<string>('');

  const handleSearch = () => {
    const filters: OrderFilterParams = {
      orderDate: orderDate ? orderDate.format('YYYY-MM-DD') : undefined,
      status: (status as any) || undefined,
      orderCode: orderCode || undefined,
      paymentMethod: (paymentMethod as any) || undefined,
      agent: agent || undefined,
    };
    onSearch(filters);
  };

  return (
    <Row gutter={[12, 12]}>
      <Col span={isDesktop ? 6 : 24}>
        <StyledDatePicker
          placeholder={
            translations?.['b2b.txt.date-order-approval'] ?? 'Ngày đặt đơn'
          }
          format={date => formatDate(date, translations)}
          onChange={event => {
            const momentValue = moment(event);
            setOrderDate(momentValue.isValid() ? momentValue : null);
          }}
          suffixIcon={<CalendarIcon />}
          value={orderDate}
          allowClear
          minWidthInput="initial"
          style={{ width: '100%' }}
        />
      </Col>
      <Col span={isDesktop ? 6 : 24}>
        <StyledSelect
          showSearch
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations?.['b2b.txt.status'] ?? 'Trạng thái'}
          options={STATUS_OPTIONS}
          style={{ width: '100%' }}
          allowClear
          onChange={(value: any) => {
            setStatus(value);
          }}
          value={status || undefined}
        />
      </Col>
      <Col span={isDesktop ? 6 : 24}>
        <StyledSearchInput
          placeholder={
            translations?.['b2c.txt.orderNumber-approval'] ?? 'Mã đặt đơn'
          }
          width="100%"
          onChange={event => {
            setOrderCode(event.target.value);
          }}
          value={orderCode}
        />
      </Col>
      <Col span={isDesktop ? 6 : 24}>
        <StyledSelect
          showSearch
          suffixIcon={<ArrowDownIcon />}
          placeholder="Chọn PTTT"
          options={paymentOptionsList}
          style={{ width: '100%' }}
          allowClear
          onChange={(value: any) => {
            setPaymentMethod(value);
          }}
          value={paymentMethod || undefined}
        />
      </Col>
      <Col span={isDesktop ? 6 : 24}>
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations?.['b2b.txt.orderer'] ?? 'Người đặt'}
          options={agentOptions}
          style={{ width: '100%' }}
          allowClear
          onChange={(value: any) => {
            setAgent(value);
          }}
          value={agent || undefined}
        />
      </Col>

      <Col
        span={isDesktop ? 4 : 24}
        style={{
          display: 'flex',
          justifyContent: isDesktop ? 'flex-end' : 'initial',
        }}
      >
        <StyledButton
          style={{
            background: '#FFFFFF',
            border: '1px solid #F8B117',
            color: '#F8B117',
            height: 44,
            flex: 1,
          }}
          onClick={handleSearch}
        >
          {translations ? translations['b2c.txt.search'] : 'Tìm kiếm'}
        </StyledButton>
      </Col>
    </Row>
  );
};
